import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'

const styles = theme => ({
  float: {
    position: 'absolute',
    right: 0,
    zIndex: 10,
    marginTop: 0,
    top: '0',
    height: '43px',
    width: '170px',
    backgroundColor: 'white',
    '@media print': {
      display: 'none'
    }
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  helperText: {
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    fontWeight: 600,
    marginLeft: 21,
    float: 'right',
    paddingTop: 9,
    useNextVariants: true,
  },
  IconButton:{
    padding: 8,
    width: 35,
    height: 35
  }
})

export const FloatIndexActions = props => {
  const {classes, helperText, d, deleteOption, handleClickOpen} = props

  return (
    <React.Fragment>

      {(deleteOption) ? (
        <IconButton className={classes.IconButton}  style={{marginLeft:'31px'}} color="default" onClick={(e) => {
          e.stopPropagation()
          handleClickOpen(d.id)
        }
        }>
          <DeleteIcon />
        </IconButton>
      ) : <div style={{width: '100px'}}> </div>}

      <Typography component="span"  variant="body2" className={classes.helperText }>
        {helperText}
      </Typography>
    </React.Fragment>

  )
}

export default withStyles(styles)(FloatIndexActions)



// WEBPACK FOOTER //
// ./src/components/FloatIndexActions.js